import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnj5c5gxgy: FaireProductEntity = {
  token: "p_bnj5c5gxgy",
  type: "product",
  name: "18K Gold PVD Stainless Steel Sunburst Chain Bracelet",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/22f1a65b576268eeb43750d5fa6157c3cc1d9b44b490eb5bbcbb6bfd3e3ee210.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bbe4e0686004eee6b1ad046c192afafc6c0c62cbeea8d11bd23b139b6b3e33a.jpeg",
    "https://cdn.faire.com/fastly/9a27735a89fc44215807f272e6416dedec2777789ff7072ed79100b5d57a7edc.jpeg",
    "https://cdn.faire.com/fastly/39920a6378e1be267182a568dcb97bf489e2f829f73389c343b0ddfbc40afab2.jpeg",
    "https://cdn.faire.com/fastly/489dd31714bac4b58919e29cb0f1213d6cefd9f53bdb35f2703aeb8be69c36e4.jpeg",
    "https://cdn.faire.com/fastly/786632ba708f1939cc3872c933180344fd1bd21ee7a8b33b19ce743965cf9d83.jpeg",
    "https://cdn.faire.com/fastly/c4eb6040247c6229d00effb59c5e484560a00dd708ea6fffb9d5bcf266b66000.jpeg",
    "https://cdn.faire.com/fastly/e35f4adde910a645511927142a2b41373817e9ca14f452b413397e4661f277b0.jpeg",
    "https://cdn.faire.com/fastly/73889049f0f5c9ba2f3ade10a5996c0c42850377eab753aac04850f7359c9e3e.jpeg",
    "https://cdn.faire.com/fastly/83c6a71575bc9f320632ad2c5246a03fbda8b8c446ef256c6537649cf930e089.jpeg",
  ],
  priceDollars: 4.13,
  description:
    'A must-have chain for the modern woman! The Sunburst Chain Bracelet—our newest essential that’s quickly becoming a standout favorite. Designed with radiant, light-catching textured circle links, this women\'s chain bracelet delivers just the right amount of sparkle to elevate any outfit. It’s the kind of chain that gets noticed—effortless, elegant, and made to shine from day to night.\n\n• Waterproof, non-tarnish, hypoallergenic\n• Premium 18K Gold PVD stainless steel\n• 7" + 1" adjustable chain extension\n• Secure lobster clasp closure\n\nPro Tip: Pair this bracelet with our matching Sunburst chain necklace (SKU: CHN0099)\n\nWhy PVD?\nWe use Physical Vapor Deposition (PVD) to coat 18K Gold over 316L stainless steel. This process ensures a high-quality, non-tarnish finish that resists wear & will never turn skin green—ideal for jewelry to be worn every day.\n\nSame day shipping from Destin, FL before 3PM CST.\nQuestions? Contact us at [redacted-email]',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:15.032Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
